const wrapperStyle = () => ({
	wrapper: {
		display: 'flex',
		padding: '10px 0 0',
		margin: 0,
	},
	iconContainer: {
		paddingRight: '6px',
	},
});

export default wrapperStyle;
